import { render, staticRenderFns } from "./Barchart.vue?vue&type=template&id=b8469656&scoped=true&"
import script from "./Barchart.vue?vue&type=script&lang=js&"
export * from "./Barchart.vue?vue&type=script&lang=js&"
import style0 from "./Barchart.vue?vue&type=style&index=0&id=b8469656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8469656",
  null
  
)

export default component.exports